import { render, staticRenderFns } from "./LiteracyEvaluationModule.vue?vue&type=template&id=39c80eac&scoped=true"
import script from "./LiteracyEvaluationModule.vue?vue&type=script&lang=js"
export * from "./LiteracyEvaluationModule.vue?vue&type=script&lang=js"
import style0 from "./LiteracyEvaluationModule.vue?vue&type=style&index=0&id=39c80eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c80eac",
  null
  
)

export default component.exports